export enum TracPageFeatureItemType {
  MusicRelease = "MusicRelease",
  MerchProduct = "MerchProduct",
  TracLink = "TracLink",
}

export interface TracPageFeatureItem {
  id: string;
  type: TracPageFeatureItemType;
}
